import PocketBase from 'pocketbase';

let _pocketbase = null as PocketBase | null;
export const pocketbase = () => {
	if (_pocketbase) {
		return _pocketbase;
	}
	_pocketbase = new PocketBase(import.meta.env.VITE_POCKETBASE_URL);
	return _pocketbase;
}
